module.exports = __webpack_public_path__ + "static/media/05-achmad.74fdfb2d.png";